module.exports = __webpack_public_path__ + "static/media/providerSilverTop1M.8af457cd.webp";